export function compareString(a, b) {
  return (a ?? '').localeCompare(b ?? '');
}

export function comparePositionInArray(a, b, array) {
  const posA = array.indexOf(a);
  const posB = array.indexOf(b);
  return posA - posB;
}
